exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ImageContent_imageContent__2vS5s {\n  width: 100%;\n  height: 76px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: left top; }\n", ""]);

// exports
exports.locals = {
	"imageContent": "ImageContent_imageContent__2vS5s"
};